<span *ngIf="observableLocales$ | async as placeholderLocales">
  <!--Hidden if not on iOS-->
  <span (click)="openTooltip()" (keydown.enter)="openTooltip()" (keydown.space)="openTooltip(); $event.preventDefault()" 
    [hidden]="!iOS" tabindex="-1" role="button" 
    [attr.aria-label]="(placeholderLocales | localebykey:localeKey:localeView)">
    <app-locale localeKey="{{tooltipKey}}" localeView="{{tooltipView}}" style="display: inline-flex" aria-hidden="true"></app-locale>
  </span>
  <!--Hidden if on iOS-->
  <span [matTooltipPosition]="tooltipPosition" matTooltip="{{placeholderLocales | localebykey:localeKey:localeView}}"
    [hidden]="iOS" [matTooltipClass]="{'custom-tooltip': true}" 
    role="img" 
    [attr.aria-label]="(placeholderLocales | localebykey:localeKey:localeView)">
    <app-locale localeKey="{{tooltipKey}}" localeView="{{tooltipView}}" style="display: inline-flex" aria-hidden="true"></app-locale>
  </span>
</span>